import getApiClient from '@/plugins/api-client'

export default {
  loadData: function () {
    const self = this,
      api = getApiClient(self.$store),
      parameters = self.filters

    api.get('/messaging_logs', {
      params: {
        page: self.currentPage,
        itemsPerPage: self.itemsPerPage,
        ...parameters
      }
    })
      .then(result => {
        self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.itemsPerPage)
        self.logs = result.data['hydra:member']
      })
      .catch(error => {
        console.log(error)
      })
  },

  setChannel(channel) {
    this.filters.channel = channel.code
  },

  clearFilters() {
    this.filters.channel = null

    this.loadData()
  },

  updatePage: function (page) {
    this.currentPage = page
  },

  openLogDetails: function (log) {
    this.showLogDetails = true
    this.logDetails = log
  },

  closeLogDetails: function () {
    this.showLogDetails = false
    this.logDetails = {}
  }
}
